import { render, staticRenderFns } from "./homeHistoryWin.vue?vue&type=template&id=a4890b20&scoped=true&"
import script from "./homeHistoryWin.vue?vue&type=script&lang=js&"
export * from "./homeHistoryWin.vue?vue&type=script&lang=js&"
import style0 from "./homeHistoryWin.vue?vue&type=style&index=0&id=a4890b20&prod&lang=less&"
import style1 from "./homeHistoryWin.vue?vue&type=style&index=1&id=a4890b20&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4890b20",
  null
  
)

export default component.exports